import React from 'react';
import { useCallback } from "react";
import { BrowserRouter as Router, Route, Routes } from 'react-router';
import { OktaAuth, toRelativeUrl } from '@okta/okta-auth-js';
import { LoginCallback, Security } from '@okta/okta-react';
import Home from "./Home";

interface AppProps {}

const App = (props: AppProps) => {
  const oktaAuth = new OktaAuth({
    issuer: process.env.REACT_APP_OKTA_ISSUER || "",
    clientId: process.env.REACT_APP_OKTA_CLIENTID || "",
    redirectUri: (process.env.REACT_APP_OKTA_BASE_REDIRECT_URI || "") + "/login/callback",
    pkce: true,
  });

  const restoreOriginalUri = useCallback(
    async (_oktaAuth: OktaAuth, originalUri: string) => {
      window.location.replace(
        toRelativeUrl(originalUri || "/", window.location.origin)
      );
    },
    []
  );

  return (
    <Router>
      <Security oktaAuth={oktaAuth} restoreOriginalUri={restoreOriginalUri}>
        <Routes>
          <Route path="/" element={<Home />}/>
          <Route path="/login/callback" element={<LoginCallback />} />
        </Routes>
      </Security>
    </Router>
  );
};

export default App;
